
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 13H4a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1v-6a1 1 0 00-1-1zm-1 6H5v-4h4v4zM20 3h-6a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-1-1zm-1 6h-4V5h4v4zm-9-6H4a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-1-1zM9 9H5V5h4v4z","fill":"url(#paint0_linearDashboardGradient)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linearDashboardGradient","x1":"4.088","y1":"20.054","x2":"20.377","y2":"4.427","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#9C27B0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#9733EE"}})])])])
          )
        }
      }
    